import FileUpload from './file-upload';
import UmbracoFormsPrePopulation from './umbraco-pre-populate';

export default [
    new FileUpload(),
    new UmbracoFormsPrePopulation(),
];
